// @file utils for surface polls

import { Poll, Post } from '@@/types'

export const isPollClosed = (poll: Poll): boolean => {
  return poll.closed_at !== null
}

export const hasPollAttachment = (post: Post): boolean => {
  return post.wish_content?.attachment_props?.type === 'poll'
}

export const getPollFromPost = (post: Post): Poll | null => {
  if (post.wish_content?.attachment_props != null && hasPollAttachment(post)) {
    return post.wish_content?.attachment_props as Poll
  }
  return null
}
